import HomePageBanner from "../components/HomePageBanner";
// import AboutSection from "../components/AboutSection";
import ServicePreviewSwiper from "../components/ServicePreviewSwiper";
import TeamPreviewSwiper from "../components/TeamPreviewSwiper";

function HomePage() {
  return (
    <div>
      <HomePageBanner />
      {/* <AboutSection /> */}
      <ServicePreviewSwiper />
      {/* <NewsPreview /> */}
      <TeamPreviewSwiper />
    </div>
  );
}
export default HomePage;
